var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseProvider } from "./base.provider";
import { injectScript } from "../utilities/dom-mutations";
import { jsonParser } from "../utilities/parsers";
export class BetgamesProvider extends BaseProvider {
    initGame(launchData) {
        const { clientScriptData } = launchData;
        const scriptData = jsonParser(clientScriptData);
        window.BetGames.setup({
            containerId: "lobby_game",
            clientUrl: scriptData.clientUrl,
            apiUrl: scriptData.serverName,
            partnerCode: scriptData.partnerId,
            partnerToken: scriptData.playerToken,
            language: scriptData.language,
            timezone: scriptData.timeZone,
            homeUrl: scriptData.homeUrl,
            defaultGame: scriptData.current_game,
            isMobile: scriptData.isMobile ? 1 : 0,
            defaultGUI: scriptData.defaultGUI ? 1 : 0,
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const { clientScriptData } = this.launchData;
            this.clientScripts = jsonParser(clientScriptData);
            const scripts = [
                {
                    url: `${this.clientScripts.clientUrl}/public/betgames.js?${Date.now()}`, // TODO: Fetch this from API
                },
            ];
            const mappedScripts = scripts.map((ejs, index) => {
                return {
                    hid: `betgamesexternalscript-${index}`,
                    src: ejs.url,
                    callback: () => this.initGame(this.launchData),
                };
            });
            injectScript(mappedScripts);
        });
    }
}
